/**
 * Allinea data-theme su <html> al tema Vuetify, così tokens.css segue
 * il pulsante chiaro/scuro già presente in Work.
 * Uso in App.vue:  import mecomThemeSync from "@/assets/mecom/vue/mecomThemeSync";
 *                  export default { mixins: [mecomThemeSync], ... }
 */
export default {
    watch: {
        "$vuetify.theme.dark": {
            immediate: true,
            handler(dark) {
                document.documentElement.setAttribute("data-theme", dark ? "dark" : "light");
                document.documentElement.style.colorScheme = dark ? "dark" : "light";
                try { localStorage.darkTheme = dark; } catch (_) { /* Storage can be unavailable. */ }
            },
        },
    },
};
